import React, {FunctionComponent, MouseEvent} from 'react';
import './QuantityPicker.less';

import {Minibutton} from 'elements/minibutton/Minibutton.tsx';
import {MinibuttonGroup} from '../minibutton-group/MinibuttonGroup';

interface QuantityPickerProps {
	value?: number,
	isBig?: boolean,
	isPressed?: boolean,
	onIncClick: (e: MouseEvent) => void,
	onDecClick: (e: MouseEvent) => void
}

export const QuantityPicker: FunctionComponent<QuantityPickerProps> = ({value, isBig = false, isPressed = false, onIncClick, onDecClick}) => {
	return (
		<MinibuttonGroup isSolid={!!value}>
			<Minibutton
				text="-"
				onClick={onDecClick}
				isTransparent={!value}
				isPressed={isPressed}
				isBig={isBig}
				key="dec-button"
			/>
			{
				(typeof value === 'number' || typeof value === 'string') && (<Minibutton
					text={value}
					isPressed={isPressed}
					isBig={isBig}
					key="value"
				/>)
			}
			<Minibutton
				text="+"
				onClick={onIncClick}
				isTransparent={!value}
				isPressed={isPressed}
				isBig={isBig}
				key="inc-button"/>
		</MinibuttonGroup>
	);
};
